angular.module('services').service('AppleIDService', ($q, $window) => {

    const deferred = $q.defer();

    const { clientId } = CWCONFIG.appleIDConfig;
    const { redirectURI } = CWCONFIG.appleIDConfig;
    const { state } = CWCONFIG.appleIDConfig;
    const { scope } = CWCONFIG.appleIDConfig;

    function init() {

        const appleSignInScript = $window.document.createElement('script');
        appleSignInScript.type = 'text/javascript';
        appleSignInScript.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
        appleSignInScript.onload = onScriptLoad;
        appleSignInScript.onerror = onScriptLoadError;

        const jsScripts = $window.document.getElementsByTagName('script')[0];
        jsScripts.parentNode.insertBefore(appleSignInScript, jsScripts);

        return deferred.promise;

    }

    function onScriptLoad() {

        if ($window.AppleID && $window.AppleID.auth) {

            $window.AppleID.auth.init({
                clientId,
                scope,
                redirectURI,
                state,
                usePopup: true,
            });

            deferred.resolve();

        }

    }

    function onScriptLoadError() {

        deferred.reject();

    }

    const exports = {
        init,
    };

    return exports;

});



// WEBPACK FOOTER //
// ./scripts/services/appleID.js